import { z } from "zod";

/**
 * Shape of the JSON body returned by `PUT /api/deployments/:id` when a WhatsApp
 * reassign was abandoned because the sender's Twilio webhook could not be
 * pointed at its connection route.
 *
 * Parsed rather than cast, for the same reason as
 * `WhatsappSenderInUseErrorSchema`: payload drift surfaces as a parse failure
 * and falls through to the generic toast, instead of narrowing to a lie.
 *
 * The message matters more than usual here. It is a 502, so the generic handler
 * classifies it as "the server broke" — the exact reading this error was
 * authored to prevent, since NOTHING changed and the number is still served by
 * its current deployment. Showing the authored copy is the whole point of the
 * error existing.
 */
export const WhatsappSenderWebhookRepointFailedErrorSchema = z.object({
  error: z.literal("WHATSAPP_SENDER_WEBHOOK_REPOINT_FAILED"),
  message: z.string(),
  /** Twilio sender SID (`XE…`) — not a UUID, so it is never validated as one. */
  senderId: z.string()
});

export type WhatsappSenderWebhookRepointFailedErrorBody = z.infer<
  typeof WhatsappSenderWebhookRepointFailedErrorSchema
>;
